import React from 'react'
import { connect } from 'react-redux'
import { Icon, Menu } from 'semantic-ui-react'

import { pauseSubscription } from 'actions/billing'

class PauseSubscriptionItem extends React.Component {
  render () {
    const { billingSubscription } = this.props
    if (billingSubscription.status !== 'active') return null

    return (
      <Menu.Item onClick={() => this.props.pause(billingSubscription.id)} title="Pause">
        <Icon name="pause"/>
      </Menu.Item>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  pause: (id) => dispatch(pauseSubscription(id))
})

export default connect(null, mapDispatchToProps)(PauseSubscriptionItem)
